<template>
  <div class="payorder">
    <div class="payorder-head">
      <p>
        {{ $t("h5page.paygame.text2") }}
      </p>
      <img
        @click="$router.push({ path: '/pay_h5/pg_record' })"
        src="@/assets/images/h5/icon20.png"
        alt=""
      />
    </div>
    <div class="payorder-state">
      <div class="payorder-state-one">
        <img src="@/assets/images/h5/icon21.png" alt="" />
        <span> {{ $t("h5page.paygame.text3") }}</span>
        <!-- <span> {{ $t("h5page.paygame.text5") }}</span> -->
      </div>
      <div class="payorder-state-two">
        {{ $t("h5page.paygame.text4") }}
      </div>
      <div
        :class="checkBtn ? 'payorder-state-three' : 'payorder-state-three colo'"
        @click="checkOrder"
      >
        <span>{{ btnMsg }}</span>
      </div>
    </div>
    <div class="payorder-state">
      <div class="payorder-state-one">
        <img src="@/assets/images/h5/icon21.png" alt="" />
        <!-- <span> {{ $t("h5page.paygame.text3") }}</span> -->
        <span> {{ $t("h5page.paygame.text5") }}</span>
      </div>
      <div class="payorder-state-three" @click="goRePay">
        <span>{{ $t("paygame.repay") }}</span>
      </div>
    </div>
    <h5-nav v-if="$region !== 'jp' "></h5-nav>
  </div>
</template>
<script>
import h5Nav from "@/component/h5nav/komoe";
export default {
  name: "pay_h5Payorder",
  components: {
    h5Nav,
  },
  data() {
    return {
      payment_url: "",
      order_no: "",
      distribution_region: 5,
      state: 1,
      btnMsg: this.$t("paygame.payTip8"),
      // 订单详情
      orderDetailInfo: {
        game_id: "",
        game_name: "",
        account: "",
        cp_role_id: "",
        cp_role_name: "",
        pay_mode: "",
        payment_desc: "",
        product_name: "",
        product_icon: "",
        marketing_desc1: "",
        marketing_desc2: "",
        product_price: "",
        currency: "",
        captcha_code: "",
        imgUrl: "",
        order_no:""
      },
      btnTime: 10,
      timeInterval: null,
      checkBtn: true,
      marketing_desc1: "",
      marketing_desc2: "",
    };
  },
  created() {
    // if (!this.$route.query.order_no) {
    //   this.$router.push({
    //     path: "/h5",
    //   });
    //   return;
    // }
    this.payment_url = this.$route.query.payment_url;
    this.order_no = this.$route.query.order_no;
    this.marketing_desc1 = this.$route.query.marketing_desc1;
    this.marketing_desc2 = this.$route.query.marketing_desc2;
  },
  methods: {
    checkOrder() {
      if (!this.timeInterval) {
        this.checkBtn = false;
        // this.btnMsg = `${this.$t("paygame.requery")} 10 ${this.$t(
        //   "paygame.requeryUnit"
        // )}`;
        this.btnMsg = this.$t("paygame.requeryAfter", { requerySeconds: 10 });
        this.timeInterval = setInterval(() => {
          // 关闭查询按钮
          this.checkBtn = false;
          this.btnTime = this.btnTime - 1;
          // this.btnMsg = `${this.$t("paygame.requery")} ${
          //   this.btnTime
          // } ${this.$t("paygame.requeryUnit")}`;
          this.btnMsg = this.$t("paygame.requeryAfter", {
            requerySeconds: this.btnTime,
          });
          if (this.btnTime <= 0) {
            clearInterval(this.timeInterval);
            this.timeInterval = null;
            this.btnMsg = this.$t("paygame.payTip9");
            this.btnTime = 10;
            this.checkBtn = true;
            // 获取订单详情
            this.getOrderDetail();
          }
        }, 1000);
      }
    },
    // loading页面 查询订单详情
    getOrderDetail() {
      if (this.order_no) {
        const _that = this;
        this.$toast.loading({
          duration: 20000,
          message: _that.$t("h5page.footernav.text4"),
          overlay: true,
          forbidClick: true,
        });
        this.$apis.paygame
          .getOrderDetail(this.distribution_region, this.order_no)
          .then(({ data }) => {
            this.$toast.clear();
            if (data.code == 0) {
              if (data.data.status == 1) {
                this.orderDetailInfo.game_id = data.data.game_id;
                this.orderDetailInfo.game_name = data.data.game_name;
                this.orderDetailInfo.account = data.data.nike_name;
                this.orderDetailInfo.cp_role_name = data.data.cp_role_name;
                this.orderDetailInfo.pay_mode = data.data.pay_mode;
                this.orderDetailInfo.payment_desc = data.data.pay_mode_name;
                this.orderDetailInfo.product_name = data.data.product_name;
                this.orderDetailInfo.marketing_desc1 = this.marketing_desc1;
                this.orderDetailInfo.marketing_desc2 = this.marketing_desc2;
                this.orderDetailInfo.product_price = data.data.product_price;
                this.orderDetailInfo.currency = data.data.currency;
                this.orderDetailInfo.order_no=data.data.order_no;
                let json = this.orderDetailInfo;
                this.$router.push({
                  path: "/pay_h5/paysucceed",
                  query: {
                    dataInfo: JSON.stringify(json),
                  },
                });
              } else {
                // 继续查询
                this.state = 2;
              }
            } else if (data.code == -101) {
              this.$router.push({
                path: "/login_h5",
                query: { redirect: location.href },
              });
            } else {
              // this.popShowPayLoading = false;
              // this.popShowPaySearch = true;
            }
          });
      }
    },
    goRePay() {
      if (this.payment_url) {
        window.open(this.payment_url);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.payorder {
  width: 100%;
  height: auto;
  margin-top: 0.48rem;
  background: white;
  &-head {
    width: 92%;
    height: 0.5rem;
    margin: auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      position: absolute;
      right: 0;
      top: 50%;
      width: 0.22rem;
      height: 0.22rem;
      transform: translateY(-50%);
    }
    p {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      font-size: 0.22rem;
      font-weight: bold;
      color: #444444;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 0.8rem;
        height: 0.04rem;
        background: #50bbe5;
        border-radius: 0.02rem;
      }
    }
  }
  &-state {
    width: 92%;
    height: 2.15rem;
    margin: auto;
    margin-top: 0.2rem;
    background: #fbfbfb;
    margin-bottom: 0.5rem;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    &-one {
      width: 100%;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 0.14rem;
        height: 0.14rem;
      }
      span {
        margin-left: 0.1rem;
        font-size: 0.13rem;
        font-weight: bold;
        color: #444444;
      }
    }
    &-two {
      width: 70%;
      height: auto;
      margin-top: 0.3rem;

      line-height: 0.15rem;
      font-size: 0.1rem;
      font-weight: 400;
      color: #999999;
    }
    &-three {
      width: 1.82rem;
      height: 0.35rem;
      margin-top: 0.3rem;
      background: #54c5f8;
      border-radius: 0.17rem;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-size: 0.12rem;
        font-weight: 400;
        color: #ffffff;
      }
    }
    .colo {
      background: #cccccc !important;
    }
  }
}
</style>
